exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-layout-AppFooter-footer{text-align:center;width:100%;min-height:60px;line-height:60px;font-weight:700;background:#11284b;color:#fff}@media screen and (max-width: 30em){.src-components-layout-AppFooter-footer{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;line-height:18px}}", ""]);

// exports
exports.locals = {
	"footer": "src-components-layout-AppFooter-footer"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/layout/AppFooter/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/layout/AppFooter/styles.scss
// module chunks = 1